import {defineStore} from 'pinia';
import {DetailView} from '@/enum/detail.view';
import {getUrlParam, updateUrlParam} from '@/utils/url.param.utils';
import {UrlParam} from '@/utils/url.param';

interface ProductTableStoreState {
	loading: boolean;
	detailView: DetailView;
}

export const useProductTableStore = defineStore('product-table', {
	state: (): ProductTableStoreState => ({
		loading: true,
		detailView: getUrlParam(UrlParam.VIEW_KEY) ?? DetailView.LIST
	}),

	getters: {
		noAvailabilityForRegionalWebSite: () => !window.isRegionalWebSiteWithAvailability
	},

	actions: {
		setDetailView(view: DetailView) {
			this.detailView = view;
			updateUrlParam(UrlParam.VIEW_KEY, view);
		},

		setLoading(loading: boolean) {
			this.loading = loading;
		}
	}
});
